module.exports = __webpack_public_path__ + "static/media/logo.44e98c87.svg";